import { TravelExploreOutlined } from '@mui/icons-material';

import ErrorPageLayout from 'views/v2/errors/components/errorPageLayout';

export default function Missing() {
    return (
        <ErrorPageLayout
            icon={<TravelExploreOutlined sx={{ fontSize: { xs: 34, sm: 38 } }} />}
            title="Page not found"
            description="We couldn't find the page you're looking for. It may have been moved, renamed, or never existed."
            iconTone="primary"
        />
    );
}
